var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apex-chart',{attrs:{"type":"treemap","series":_vm.series,"options":_vm.chartOptions,"height":"95%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }